import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-business-lending-vaf-cmb-v2.component.scss';
var FormItemBusinessLendingVafCmbV2 = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemBusinessLendingVafCmbV2, _super);
    function FormItemBusinessLendingVafCmbV2(element) {
        return _super.call(this, element) || this;
    }
    FormItemBusinessLendingVafCmbV2.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.wizard = this.element.querySelector(".form-container-wizard__wizard");
        // display views
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector('.form-container__error');
        }
        this.buttonSubmit = this.element.querySelector(".js-businessLendingVafCmb__submit");
        this.hidLeadId = this.form.querySelector("input[name=leadId]");
        this.hidProduct = this.form.querySelector("input[name=product]");
        this.selectProvince = this.element.querySelector(".js-vaf__province");
        if (this.selectProvince) {
            this.updateProvince();
        }
        this.hiddenEmail = this.element.querySelector("input[name=email]");
        this.hiddenRecipient = this.element.querySelector("input[name=recipient]");
        this.entityType = this.element.querySelector(".js-apply-now-entity-type");
        this.businessFields = Array.from(this.element.querySelectorAll(".js-business-apply-now-vaf-cmb"));
        this.southAfricanIdField = this.element.querySelector(".js-hs-apply-now-vissible-id");
        if (this.entityType) {
            this.updateForm(this.entityType.value);
        }
    };
    FormItemBusinessLendingVafCmbV2.prototype.bindEvents = function () {
        var _this = this;
        if (this.buttonSubmit) {
            this.buttonSubmit.addEventListener("click", function (pEvent) {
                var _button = pEvent.target;
                var _form = _button.closest("form");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.submitForm(_form);
                }
            });
        }
        if (this.entityType) {
            this.entityType.addEventListener("change", function (pEvent) {
                _this.updateForm(_this.entityType.value);
            });
        }
        if (this.selectProvince) {
            this.selectProvince.addEventListener("click", function (pEvent) {
                _this.updateProvince();
            });
        }
        // This adds slashes to the business registration number
        var businessReg = this.element.querySelector(".js-business-apply-now-vaf-cmb");
        if (businessReg) {
            businessReg.addEventListener("input", function (pEvent) {
                if ((pEvent.inputType !== "deleteContentBackward") && (pEvent.inputType !== "deleteContentForward")) {
                    var reg = pEvent.target.value;
                    pEvent.target.value = _this.validationService.formatBusinessReg(reg);
                }
            });
            businessReg.addEventListener("blur", function (pEvent) {
                var reg = pEvent.target.value;
                pEvent.target.value = _this.validationService.formatExpression(reg);
            });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (pEvent) {
            // This will reset step 2
            if (_this.entityType) {
                _this.updateForm(_this.entityType.value);
            }
            if (_this.wizard) {
                var event_1 = new CustomEvent("custom_wizard_reset_event");
                _this.wizard.dispatchEvent(event_1);
            }
            _this.showDisplayView("");
        }, false);
    };
    FormItemBusinessLendingVafCmbV2.prototype.updateProvince = function () {
        if (this.hiddenEmail) {
            this.hiddenEmail.value = "website@standardbank.co.za";
        }
        if (this.hiddenRecipient) {
            switch (this.selectProvince.value) {
                case "Western Cape":
                    this.hiddenRecipient.value = "CAFOnline@standardbank.co.za,Nicolaas.Arends@standardbank.co.za,Malikah.Booley@standardbank.co.za";
                    break;
                case "Gauteng":
                    this.hiddenRecipient.value = "CAFOnline@standardbank.co.za,Denise.Ngwetsheni@standardbank.co.za,Jaco.Roux@standardbank.co.za";
                    break;
                case "Kwazulu Natal":
                    this.hiddenRecipient.value = "CAFOnline@standardbank.co.za,Vikash.Baijnath@standardbank.co.za,Anneline.Pillay@standardbank.co.za";
                    break;
                case "Limpopo":
                    this.hiddenRecipient.value = "CAFOnline@standardbank.co.za,Muneer.Shaik@standardbank.co.za";
                    break;
                case "Mpumalanga":
                    this.hiddenRecipient.value = "CAFOnline@standardbank.co.za,Muneer.Shaik@standardbank.co.za";
                    break;
                case "Eastern Cape":
                    this.hiddenRecipient.value = "CAFOnline@standardbank.co.za,Roberto.DeSouza@standardbank.co.za";
                    break;
                case "Free State / Northern Cape":
                    this.hiddenRecipient.value = "CAFOnline@standardbank.co.za,Gabriel.Seloana@standardbank.co.za,Christo.VanWyk@standardbank.co.za";
                    break;
                case "North West":
                    this.hiddenRecipient.value = "CAFOnline@standardbank.co.za,Christo.VanWyk@standardbank.co.za,Gabriel.Seloana@standardbank.co.za";
                    break;
                default:
                    this.hiddenRecipient.value = "enterprisedirect2@standardbank.co.za";
                    break;
            }
        }
    };
    FormItemBusinessLendingVafCmbV2.prototype.updateForm = function (pType) {
        if (this.southAfricanIdField) {
            var _group = this.southAfricanIdField.closest(".form__group");
            if (pType !== "SOLE") {
                this.southAfricanIdField.classList.remove("form__input--required");
                _group.classList.add("form__group--hidden");
            }
            else {
                this.southAfricanIdField.classList.add("form__input--required");
                _group.classList.remove("form__group--hidden");
            }
        }
        if (this.businessFields) {
            this.businessFields.forEach(function (elem) {
                var _group = elem.closest(".form__group ");
                if (pType !== "SOLE") {
                    elem.classList.add("form__input--required");
                    _group.classList.remove("form__group--hidden");
                }
                else {
                    elem.classList.remove("form__input--required");
                    _group.classList.add("form__group--hidden");
                }
            });
        }
    };
    FormItemBusinessLendingVafCmbV2.prototype.submitForm = function (pForm) {
        var _this = this;
        var _serviceType = pForm.querySelector("input[name=service-type]");
        var _loanAmount = this.form.querySelector("input[name=loan-amount]");
        var _firstname = this.form.querySelector("input[name=first-name]");
        var _surname = this.form.querySelector("input[name=last-name]");
        var _contactNumber = this.form.querySelector("input[name=phone-number]");
        var _alternativeContactNumber = this.form.querySelector("input[name=alternative-number]");
        var _idNumber = this.form.querySelector("input[name=sa-identity-number]");
        var _businessAccountCurrentlyHeld = this.form.querySelector("select[name=business-account]");
        var _accountNumber = this.form.querySelector("input[name=account-number]");
        var _entityType = this.form.querySelector("select[name=entity-type]");
        var _businessName = this.form.querySelector("input[name=business-name]");
        var _province = this.form.querySelector("select[name=province");
        var _businessRegNumber = this.form.querySelector("input[name=business-reg-number]");
        var _emailAddress = this.form.querySelector("input[name=email-address]");
        var _existingQuote = this.form.querySelector("select[name=existing-quote]");
        var _businessDescription = this.form.querySelector("input[name=business-do]");
        var _purpose = this.form.querySelector("textarea[name=purpose]");
        var _turnOver = this.form.querySelector("input[name=turnover-tax]");
        var _description = pForm.querySelector("input[name=description]");
        var _recipient = pForm.querySelector("input[name=recipient]");
        var _subject = pForm.querySelector("input[name=subject]");
        var _product = pForm.querySelector("input[name=product]");
        var _redirect = pForm.querySelector("input[name=redirect]");
        var _email = pForm.querySelector("input[name=email]");
        var _popiaConsent = pForm.querySelector("input[name=terms-and-conditions]");
        var _postData = {
            'serviceType': (_serviceType ? _serviceType.value : ""),
            'howMuchDoYouNeed': (_loanAmount ? _loanAmount.value : ""),
            'firstName': (_firstname ? _firstname.value : ""),
            'surname': (_surname ? _surname.value : ""),
            'contactNo': (_contactNumber ? _contactNumber.value : ""),
            'altContactNo': (_alternativeContactNumber ? _alternativeContactNumber.value : ""),
            'saId': (_idNumber ? _idNumber.value : ""),
            'bankName': (_businessAccountCurrentlyHeld ? _businessAccountCurrentlyHeld.value : ""),
            'bankAccountNo': (_accountNumber ? _accountNumber.value : ""),
            'province': (_province ? _province.value : ""),
            'entityType': (_entityType ? _entityType.value : ""),
            'businessName': (_businessName ? _businessName.value : ""),
            'businessRegistration': (_businessRegNumber ? _businessRegNumber.value : ""),
            'emailAddress': (_emailAddress ? _emailAddress.value : ""),
            'hasExistingVehicleQuote': (_existingQuote ? _existingQuote.value : ""),
            'businessDescription': (_businessDescription ? _businessDescription.value : ""),
            'purpose': (_purpose ? _purpose.value : ""),
            'monthlyTurnOver': (_turnOver ? _turnOver.value : ""),
            'description': (_description ? _description.value : ""),
            'email': (_email ? _email.value : ""),
            'recipient': (_recipient ? _recipient.value : ""),
            'subject': (_subject ? _subject.value : ""),
            'product': (_product ? _product.value : ""),
            'redirect': (_redirect ? _redirect.value : ""),
            'consent': ((_popiaConsent ? (_popiaConsent.checked ? "YES" : "NO") : "NO")),
        };
        this.showDisplayView("loader");
        // variables
        var url = this.baseUrl + "/leadsutils/savebusinessvaf";
        var _config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, _postData, _config).then(function (pResponse) {
            if (pResponse.data === "invalid") {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                _this.showDisplayView("error");
            }
            else {
                _this.analyticsService.dtmFormComplete("complete", pResponse.code);
                _this.showDisplayView("success");
            }
        }).catch(function (pError) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FormItemBusinessLendingVafCmbV2.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
                break;
        }
    };
    return FormItemBusinessLendingVafCmbV2;
}(Base));
export { FormItemBusinessLendingVafCmbV2 };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-business-lending-vaf-cmb-v2/form-item-business-lending-vaf-cmb-v2.component.ts
// module id = 603
// module chunks = 0